// import detOultet from "@/modules/outlet/outlet/store/state";

import conn from "@/store/utils/connection";

const getters = {
	getOutlet: (state) => state.outlet,
	getDetailOutlet: (state) => state.detailOultet,
}

export default getters